import gql from 'graphql-tag';
import { useMutation } from '@apollo/react-hooks';
import {
  CreateLeadFormJobMutation,
  CreateLeadFormJobMutationVariables
} from './__generated__/CreateLeadFormJobMutation';
import { kmsClient } from '../../apollo';

const CREATE_LEAD_FORM_JOB_MUTATION = gql`
  mutation CreateLeadFormJobMutation(
    $articleDataInput: [ArticleDataInput!]!
    $leadgenFormInput: FacebookLeadgenFormInput!
  ) {
    createJobsFacebookLeadgenFormsCreateJob(articleDataInput: $articleDataInput, leadgenFormInput: $leadgenFormInput) {
      jobsFacebookLeadgenFormsMutateJob {
        id
        status
        items {
          id
          leadgenFormId
          itemErrors
          article {
            id
          }
        }
        jobErrors
      }
      errors
    }
  }
`;

export const useCreateLeadFormJobMutation = () => {
  return useMutation<CreateLeadFormJobMutation, CreateLeadFormJobMutationVariables>(CREATE_LEAD_FORM_JOB_MUTATION, {
    client: kmsClient
  });
};
